// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"713cf279","830":"82c1eb09"}[chunkId] + ".chunk.js";
};